import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import TextButton from 'components/TextButton';
import IconClose from 'resources/close-gray.png';
import './DebouncedTextInput.css';

class DebouncedTextInput extends PureComponent {
  timeoutId = null;
  state = {
    value: ''
  };

  componentWillUnmount() {
    clearTimeout(this.timeoutId);
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    const { defaultValue } = nextProps;

    return defaultValue === prevState.defaultValue
      ? { defaultValue }
      : { value: defaultValue, defaultValue };
  }

  onInputChange = event => {
    let inputValue = event.target.value;
    if (this.props.parseFn) {
      inputValue = this.props.parseFn(inputValue);
    }

    this.setState({ value: inputValue });

    clearTimeout(this.timeoutId);
    this.timeoutId = setTimeout(() => {
      this.timeoutId = null;
      this.props.onChange(inputValue);
    }, 500);
  };

  onInputBlur = event => {
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
      this.timeoutId = null;
      this.props.onChange(this.state.value);
      if (this.props.onBlur) {
        // Give the page a chance to re-render before calling the blur handler
        setTimeout(() => this.props.onBlur(event), 0);
      }
    } else if (this.props.onBlur) {
      this.props.onBlur(event);
    }
  };

  onClose = () => {
    this.setState({ value: '' });
    this.props.onClear();
  };

  render() {
    const { defaultValue, onChange, onBlur, onClear, parseFn, ...otherProps } =
      this.props;
    return (
      <>
        <input
          {...otherProps}
          onChange={this.onInputChange}
          onBlur={this.onInputBlur}
          value={this.state.value}
        />
        {onClear && (
          <TextButton className="debounced-close-button" onClick={this.onClose}>
            <img src={IconClose} alt="Close" />
          </TextButton>
        )}
      </>
    );
  }
}

DebouncedTextInput.propTypes = {
  type: PropTypes.string,
  defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onChange: PropTypes.func,
  className: PropTypes.string,
  maxLength: PropTypes.number,
  parseFn: PropTypes.func
};

export default DebouncedTextInput;
